import { Box, Typography } from "@mui/material";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { useContext } from "react";
import { GlobalContext } from "../../../../common/Context";
import { green, purple, text, white } from "../../../../../theme/colours";
import { TotalIcon } from "../../../../common/Icons";
import { SRC_TIER_NAV } from "../../../../../constants/ids";

const TierNav = ({ fullUserTiers, currTeam, setCurrTeam, setCurrTier }) => {
  const { mobileView, tabletView } = useContext(GlobalContext);

  const containerStyle = (isActive) => ({
    borderRadius: "0.5rem",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "2rem",
    px: "0.75rem",
    background: isActive && `linear-gradient(90deg, ${purple[1]}, ${green[1]})`,
    border: "1px solid",
    borderColor: isActive ? white : text.primary,
  });
  const textStyle = (isActive) => ({
    whiteSpace: "nowrap",
    fontWeight: 600,
    color: isActive && white,
  });
  const imageStyle = (isActive) => ({
    margin: "0 0.25rem 0 0.5rem",
    width: mobileView || tabletView ? "25px" : "19px",
    fill: isActive ? white : text.primary,
  });
  const arrowStyle = {
    mx: "0.75rem",
    color: text.primary,
    fontSize: "1rem",
  };

  const handleClick = (tier) => {
    setCurrTeam(tier);
    setCurrTier(tier.type);
  };

  return fullUserTiers?.map((tier, index) => {
    if (!tier) return;
    const isActive = tier.id === currTeam.id;

    return (
      <>
        <Box
          sx={containerStyle(isActive)}
          onClick={() => handleClick(tier)}
          id={SRC_TIER_NAV(tier.id)}>
          <Typography sx={textStyle(isActive)}>{tier.name}</Typography>
          <TotalIcon style={imageStyle(isActive)} />
          <Typography sx={textStyle(isActive)}>{tier.score}</Typography>
        </Box>
        {index + 1 < fullUserTiers.length && (
          <ArrowForwardIcon sx={arrowStyle} />
        )}
      </>
    );
  });
};

export default TierNav;
